const API_URL = 'https://onboard.prudencier.com/api/onboard';
export const AUTH_API_URL = 'https://ec2kc.prudencier.com';

export const login = async (email, password) => {
  const response = await fetch(`${AUTH_API_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, password })
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Login failed');
  return data.access_token;
};

export const signup = async ({
  name,
  email,
  password,
  phone,
  gstNo,
  addressLine1,
  addressLine2,
  pinCode,
  state,
  fssaiRegNo,
  location
}) => {
  const response = await fetch(`${AUTH_API_URL}/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name,
      email,
      password,
      phone,
      gst_no: gstNo,
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      pin_code: pinCode,
      state,
      fssai_registration_number: fssaiRegNo,
      location: location || { latitude: 0, longitude: 0 },
      user_type: 'ROLE_restaurant_manager'
    })
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Signup failed');
  return data;
};

export const logout = async (token) => {
  const response = await fetch(`${AUTH_API_URL}/auth/logout`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) throw new Error('Logout failed');
  return true;
};

export const submitRestaurant = async (token, data) => {
  const response = await fetch(`${API_URL}/restaurant`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ ...data, idempotency_key: crypto.randomUUID() })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Restaurant submission failed');
  return result;
};

export const submitMenu = async (token, data) => {
  const response = await fetch(`${API_URL}/menu`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ ...data, idempotency_key: crypto.randomUUID() })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Menu submission failed');
  return result;
};

export const submitImages = async (token, restaurant_staging_id, files) => {
  const formData = new FormData();
  formData.append('restaurant_staging_id', restaurant_staging_id);
  const idempotencyKeys = Array.from(files).map(() => crypto.randomUUID());
  formData.append('idempotency_keys', JSON.stringify(idempotencyKeys));
  Array.from(files).forEach(file => formData.append('images', file));

  const response = await fetch(`${API_URL}/images`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
    body: formData
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Image upload failed');
  return result;
};

export const fetchAPI = async (endpoint, options = {}, baseURL = API_URL) => {
  const url = `${baseURL}${endpoint}`;
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'API request failed');
    }
    return data;
  } catch (error) {
    console.error('API fetch error:', error);
    throw error;
  }
};
